import DisplayActionsInformation from './DisplayActionsInformation'

export default DisplayActionsInformation
